module.exports = __webpack_public_path__ + "assets/EmptyDocumentMyChoice-607468bf7d4f71622baa538c1b7682e5.pdf";